import moize from 'moize';
import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from '@/store/hooks';
const initialCollectionsState = {
    items: [],
    loaded: false,
    loading: false,
    error: null,
};
// Base selector to get collections state from Redux store
const getCollectionsState = (state) => { var _a; return (_a = state.collections) !== null && _a !== void 0 ? _a : initialCollectionsState; };
// Base selector to get collections items from state
const getCollections = createSelector([getCollectionsState], (collectionsState) => { var _a; return (_a = collectionsState.items) !== null && _a !== void 0 ? _a : []; });
export const collectionsLoadedSelector = createSelector([getCollectionsState], (collectionsState) => collectionsState.loaded);
// Memoized selector that sorts collections only when the array changes
// Create a new array before sorting to avoid mutating Immer-managed state
export const collectionsSelector = createSelector([getCollections], (collections) => (collections
    ? [...collections].sort((a, b) => { var _a; return (_a = a === null || a === void 0 ? void 0 : a.collection) === null || _a === void 0 ? void 0 : _a.localeCompare(b === null || b === void 0 ? void 0 : b.collection); })
    : []));
export const collectionById = moize((id) => createSelector(collectionsSelector, (collections) => collections.find((collection) => collection.id === id)));
export const collectionIdByName = moize((collectionName) => createSelector(collectionsSelector, (collections) => { var _a; return (_a = collections.find(({ collection }) => collection === collectionName)) === null || _a === void 0 ? void 0 : _a.id; }));
export const useCollectionsSelector = () => useAppSelector(collectionsSelector);
export const useCollectionsLoadedSelector = () => useAppSelector(collectionsLoadedSelector);
export const useCollectionById = (id) => useAppSelector(collectionById(id));
export const collectionNameByProjectId = moize((id) => createSelector(collectionsSelector, (collections) => collections.find(({ projectId }) => projectId === id).collection));
export const useCollectionNameByProjectIdSelector = (id) => useAppSelector(collectionNameByProjectId(id));
/** @deprecated Typo — use {@link useCollectionNameByProjectIdSelector} instead. */
export const useCollectionNameByPojectIdSelector = useCollectionNameByProjectIdSelector;
